import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import PersonnelAdjustment from 'features/Project/pages/PersonnelAdjustment';

function PersonnelAdjustmentCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <PersonnelAdjustment />
      </Layout>
    </LayoutProvider>
  );
}

export default PersonnelAdjustmentCreatePage;
